<!-- Start Hero -->
<!--[ngClass]="title == 'team' ? 'header-team' : 'header-default'"-->
<section class="relative table w-full py-28 bg-manual bg-top bg-no-repeat bg-cover" [ngStyle]="{'background-image': 'url('+currentHeader()+')'}">
  <div class="absolute inset-0 bg-earth/70 bg-gradient-to-b from-earth-try to-[transparent]"></div>
  <!-- bg-earth/90 -->
  <div class="container">
      <div class="grid grid-cols-1 text-center">
        <img class="mx-auto w-72" src="assets/images/logo_square_gold.png" />
          <!--<h3 class="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white"></h3>-->
          <!--{{ cap(title) }}-->
      </div><!--end grid-->
  </div><!--end container-->

  <!--<div class="absolute text-center z-10 bottom-5 right-0 left-0 mx-3">
      <ul class="breadcrumb tracking-[0.5px] breadcrumb-light mb-0 inline-block">
         <li class="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white/50 hover:text-white"><a href="index.html">Mudico</a></li>
         <li class="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white/50 hover:text-white"><a href="job-grid-two.html">Pagename</a></li>
      </ul>
  </div>-->
</section><!--end section-->
<div class="relative">
  <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-white dark:text-slate-900">
      <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
  </div>
</div>
<!-- End Hero -->
